import { boxShadowValuesV2 } from '@shared/utils/style/dropShadows';
import { styled } from '@withjoy/joykit';

export const DrawerLayout = styled.div<{
  readonly $isOpen: boolean;
  readonly $isSizedToParent?: boolean;
}>`
  position: absolute;
  ${({ $isSizedToParent }) => ($isSizedToParent ? 'top: 0;' : 'height: 100vh; height: 100dvh;')}
  overflow-y: ${({ $isOpen }) => ($isOpen ? 'auto' : 'hidden')};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
`;

const SCREEN_HEIGHT_MIN_HEIGHT = `
  min-height: calc(100vh - (var(--drawer-open-position-vh) * 1vh) - var(--drawer-open-position-offset-px));
  min-height: calc(100dvh - (var(--drawer-open-position-vh) * 1dvh) - var(--drawer-open-position-offset-px));
`;

export const DrawerContent = styled.div<{
  /** Optional sheet background; defaults to white so existing consumers are unchanged. */
  readonly $backgroundColor?: string;
  /** Grows to fill the wrapper, which is sized to the parent, instead of taking the screen's height. */
  readonly $isSizedToParent?: boolean;
}>`
  box-shadow: ${boxShadowValuesV2?.hardxs};
  pointer-events: auto;
  background-color: ${({ $backgroundColor }) => $backgroundColor ?? 'white'};
  border-top-left-radius: ${({ theme }) => theme.radii[4]};
  border-top-right-radius: ${({ theme }) => theme.radii[4]};
  ${({ $isSizedToParent }) => ($isSizedToParent ? 'flex: 1 0 auto;' : SCREEN_HEIGHT_MIN_HEIGHT)}
`;

export const ScrollTopContainer = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.space[1]};
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 11;
  pointer-events: auto;
`;
